import React, { useEffect, useId, useState } from 'react';
import api from '../api';
import { fiscalName } from '../utils/fiscalName';

// One catalog request per mounted picker; searches include every national service.
export default function NfseServicePicker({ value, onChange, label = 'Código nacional do serviço', disabled = false }) {
  const id = useId();
  const [catalog, setCatalog] = useState([]);
  const [query, setQuery] = useState('');
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    api.get('/nfse/integration/service-catalog', { params: { all: true } }).then(response => {
      if (active) setCatalog(Array.isArray(response.data) ? response.data : response.data?.results || response.data?.items || []);
    }).catch(() => { if (active) setError('Não foi possível carregar a lista oficial. Tente reabrir esta seção.'); })
      .finally(() => { if (active) setBusy(false); });
    return () => { active = false; };
  }, []);
  const matches = catalog.filter(item => fiscalName(`${item.code} ${item.description || item.label || ''}`).includes(fiscalName(query)));
  const selected = catalog.find(item => item.code === value);
  return <div className="space-y-2 text-sm">
    <label htmlFor={id} className="block font-medium text-slate-700">{label}</label>
    <p className="text-xs text-slate-600">Selecionado: {value || 'nenhum'}{selected ? ` · ${selected.description || selected.label}` : ''}</p>
    <input id={id} type="search" disabled={disabled} value={query} onChange={event => setQuery(event.target.value)} placeholder="Pesquisar código ou descrição oficial" className="w-full rounded-lg border px-3 py-2" />
    {busy && <p role="status">Carregando catálogo oficial...</p>}
    {error && <p role="alert">{error}</p>}
    {!busy && !error && <><p className="text-xs text-slate-500">{matches.length} serviços encontrados</p>
      <div className="max-h-56 overflow-y-auto rounded-lg border" role="listbox" aria-label={`${label}: resultados`}>
        {matches.map(item => <button type="button" role="option" aria-selected={item.code === value} disabled={disabled} key={item.code} onClick={() => onChange(item.code)} className="block w-full border-b px-3 py-2 text-left text-xs hover:bg-blue-50">{item.code} · {item.description || item.label}</button>)}
        {!matches.length && <p className="p-3 text-xs">Nenhum serviço encontrado.</p>}
      </div></>}
  </div>;
}
